import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {
	ShoppingCartIcon,
	ChevronRightIcon } from '@heroicons/react/outline'

class OrdersCard extends Component {
	_formatTime = (timestamp) => {
		const date = new Date(timestamp * 1000)
		let hours = date.getHours()
		let minutes = date.getMinutes()
		if (hours < 10)
			hours = '0' + hours
		if (minutes < 10)
			minutes = '0' + minutes
		return hours + 'h' + minutes
	}

	_orderLabel = (order) => {
		let label = this.props.benefitNames[order.service_benefit] || 'Commande'
		let client = ''
		if (order.firstname || order.lastname)
			client = ((order.firstname || '') + ' ' + (order.lastname || '')).trim()
		else if (order.user && order.user.firstname)
			client = (order.user.firstname + ' ' + (order.user.lastname || '')).trim()
		if (client.length > 0)
			label += ' · ' + client
		return label
	}

	_cartSummary = (order) => {
		const cart = order.cart
		if (!cart || cart.length === 0)
			return null
		const lang = this.props.langDefault || 'fr'
		const parts = []
		for (let i = 0; i < cart.length; i++)
		{
			const item = cart[i]
			const qty = Number(item.quantity) || 1
			let name = null
			const translations = item.translations || []
			for (let j = 0; j < translations.length; j++)
			{
				if (translations[j].lang === lang)
				{
					name = translations[j].subtitle || translations[j].name || translations[j].title
					break
				}
			}
			if (name === null && translations.length > 0)
				name = translations[0].subtitle || translations[0].name || translations[0].title
			if (name)
				parts.push(qty + '× ' + name)
		}
		if (parts.length === 0)
			return null
		return parts.join(', ')
	}

	render() {
		if (this.props.loading === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 animate-pulse">
					<div className="h-3 bg-slate-200 rounded-full w-1/3 mb-4"></div>
					<div className="h-8 bg-slate-200 rounded-lg w-1/4 mb-4"></div>
					<div className="h-4 bg-slate-100 rounded mb-2"></div>
					<div className="h-4 bg-slate-100 rounded w-2/3"></div>
				</div>
			)
		}
		if (this.props.error === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-2">Commandes du jour</h2>
					<p className="text-sm font-medium text-slate-500 mt-0 mb-3">Données indisponibles.</p>
					<button
						type="button"
						onClick={this.props.onRetry}
						className="inline-flex items-center px-4 py-2 text-2xs font-black uppercase tracking-widest rounded-xl text-indigo-700 cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						style={{ backgroundImage: 'none', backgroundColor: '#eef2ff' }}
					>
						Réessayer
					</button>
				</div>
			)
		}
		const pending = this.props.pending || []
		return (
			<div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
				<div className="flex items-center justify-between px-5 pt-5 pb-3">
					<div>
						<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest my-0">Commandes du jour</h2>
						{pending.length > 0 &&
							<p className="text-2xl font-black text-slate-900 mt-1 mb-0 leading-none">{pending.length} <span className="text-sm font-bold text-slate-400">à préparer</span></p>
						}
					</div>
					<Link to="/services/commandes" className="group flex items-center gap-1 text-2xs font-black uppercase tracking-widest text-indigo-600 hover:text-indigo-800 cursor-pointer transition-colors whitespace-nowrap">
						Voir tout
						<ChevronRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
					</Link>
				</div>
				{pending.length === 0 &&
					<div className="flex items-center gap-3 px-5 pb-5">
						<div className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center flex-shrink-0">
							<ShoppingCartIcon className="w-5 h-5 text-slate-400" aria-hidden="true" />
						</div>
						<p className="text-sm font-medium text-slate-500 my-0">
							Aucune commande à préparer aujourd'hui.
							{this.props.totalToday > 0 &&
								<span className="font-bold text-emerald-600"> {this.props.totalToday} déjà traitée{(this.props.totalToday > 1) ? 's' : ''}.</span>
							}
						</p>
					</div>
				}
				{pending.length > 0 &&
					<>
						<div>
							{pending.slice(0, 5).map(order => {
								const cart = this._cartSummary(order)
								return (
									<div key={order._id} className="flex items-start gap-3 px-5 py-2.5 border-t border-slate-100">
										<span className="text-xs font-black text-slate-900 bg-slate-100 rounded-lg px-2 py-1 flex-shrink-0" style={{ marginTop: 2 }}>{this._formatTime(order.start)}</span>
										<div className="min-w-0">
											<span className="text-sm font-semibold text-slate-600 truncate block">{this._orderLabel(order)}</span>
											{cart && <span className="text-xs text-slate-400 font-medium truncate block" style={{ marginTop: 2 }}>{cart}</span>}
										</div>
									</div>
								)
							})}
						</div>
						{pending.length > 5 &&
							<p className="px-5 py-3 my-0 text-xs font-bold text-slate-400 border-t border-slate-100">+ {pending.length - 5} autre{(pending.length - 5 > 1) ? 's' : ''} commande{(pending.length - 5 > 1) ? 's' : ''}</p>
						}
					</>
				}
			</div>
		)
	}
}

export default OrdersCard
